import React from "react";

export default function DegreeIcon({ className = "svg-308", ...props }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="100%" viewBox="0 0 20 20" fill="none" className={className} aria-hidden="true" {...props}>
      <rect width="20" height="20" rx="10" fill="#FAF5FF" />
      <path
        d="M5.33334 8.54175V12.5123C5.33334 12.7292 5.33334 12.8377 5.36719 12.9327C5.39711 13.0166 5.44587 13.0926 5.50973 13.1548C5.58197 13.2251 5.68059 13.2703 5.8778 13.3607L9.61113 15.0718C9.75419 15.1374 9.82571 15.1702 9.90023 15.1831C9.96625 15.1946 10.0338 15.1946 10.0998 15.1831C10.1743 15.1702 10.2458 15.1374 10.3889 15.0718L14.1222 13.3607C14.3194 13.2703 14.4181 13.2251 14.4903 13.1548C14.5542 13.0926 14.6029 13.0166 14.6328 12.9327C14.6667 12.8377 14.6667 12.7292 14.6667 12.5123V8.54175"
        stroke="#9333EA"
        strokeWidth="1.16667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.9167 11.4584V9.70516C12.9167 9.60047 12.9167 9.54812 12.9007 9.5019C12.8866 9.46103 12.8636 9.42381 12.8334 9.39292C12.7992 9.35799 12.7523 9.33458 12.6587 9.28776L9.99999 7.95841M4.16666 7.95841L9.79129 5.1461C9.86781 5.10783 9.90607 5.0887 9.94621 5.08117C9.98175 5.0745 10.0182 5.0745 10.0538 5.08117C10.0939 5.0887 10.1322 5.10783 10.2087 5.1461L15.8333 7.95841L10.2087 10.7707C10.1322 10.809 10.0939 10.8281 10.0538 10.8357C10.0182 10.8423 9.98175 10.8423 9.94621 10.8357C9.90607 10.8281 9.86781 10.809 9.79129 10.7707L4.16666 7.95841Z"
        stroke="#9333EA"
        strokeWidth="1.05"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
